import React from 'react';
import createIconComponent from '../utils/createIconComponent';
var LogoSonos = createIconComponent({
  iconData: {
    "tag": "svg",
    "attr": {
      "dataName": "Layer 1",
      "viewBox": "0 0 514.55 106.88",
      "aria-hidden": "true",
      "focusable": "false",
      "fill": "currentColor",
      "width": "1em",
      "height": "1em"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "fill": "currentColor",
        "d": "M278.88 60.37L218.49 4.08v95.44h17.89v-53.3l60.39 56.22V6.75h-17.89v53.62zM140.06 3.16a50.1 50.1 0 1050.09 50.1 50.15 50.15 0 00-50.09-50.1zm0 82.19a32.09 32.09 0 1131.77-32.09 32 32 0 01-31.77 32.09zM59.5 54.09c-4.76-3.63-11-6.56-20.33-9.52C21 38.81 21 34.23 21 32c0-5.16 5.76-10.5 15.39-10.5a29.08 29.08 0 0116.75 5.79l1.25.94 14.43-9.75-1.58-1.87A42.19 42.19 0 0036.42 3.18c-9.28 0-17.81 3-24 8.35A27.37 27.37 0 002.67 32c0 8.22 3.59 15.13 10.67 20.53 4.76 3.63 11 6.56 20.33 9.52 18.14 5.77 18.14 10.34 18.14 12.53 0 5.16-5.76 10.5-15.39 10.5a29 29 0 01-16.75-5.79l-1.25-.94L4 88.14 5.57 90a42.19 42.19 0 0030.85 13.47c9.28 0 17.81-3 24-8.35a27.37 27.37 0 009.73-20.51c.02-8.21-3.57-15.12-10.65-20.52zM375.19 3.53a50.1 50.1 0 1050.1 50.09 50.14 50.14 0 00-50.1-50.09zm0 82.18A32.09 32.09 0 11407 53.62a32 32 0 01-31.81 32.09zM455.76 52.79c4.75 3.63 11 6.56 20.33 9.52 18.14 5.76 18.14 10.34 18.14 12.54 0 5.15-5.76 10.49-15.39 10.49a29.08 29.08 0 01-16.75-5.79l-1.25-.93-14.43 9.74 1.59 1.87a42.24 42.24 0 0030.86 13.47c9.28 0 17.8-3 24-8.35a27.37 27.37 0 009.73-20.5c0-8.23-3.59-15.14-10.68-20.54-4.75-3.63-11-6.56-20.32-9.52-18.14-5.79-18.14-10.33-18.14-12.53 0-5.16 5.75-10.5 15.39-10.5a29 29 0 0116.75 5.79l1.25.94 14.42-9.75-1.57-1.87A42.23 42.23 0 00478.84 3.4c-9.28 0-17.81 3-24 8.35a27.39 27.39 0 00-9.73 20.51c-.02 8.22 3.57 15.13 10.65 20.53z"
      }
    }]
  }
});
LogoSonos.displayName = 'LogoSonos';
export default LogoSonos;